import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Testimonial = () => {
  const testimonials = [
    {
      stars: "★★★★★",
      text: `"Using Diddy Baby Oil has been a game-changer for me and my partner. It has this incredible silky feel, and its subtle scent is just perfect. We feel so much more connected, and it's brought a fresh sense of passion to our relationship. Highly recommend it to anyone looking to enhance those special moments!"`,
      author: "Amanda R.",
      location: "Austin, TX",
    },
    {
      stars: "★★★★★",
      text: `"I was a bit hesitant, but Diddy Baby Oil exceeded my expectations. It feels amazing on the skin, and my partner loves it too! It's really added a sense of warmth and intimacy to our time together. Worth every penny!"`,
      author: "Jake L.",
      location: "Denver, CO",
    },
    {
      stars: "★★★★★",
      text: `"Diddy Baby Oil has brought a whole new level of connection to my relationship. The texture is amazing and really makes the experience feel extra special. It's subtle yet sensual, and both my partner and I love it!"`,
      author: "Donnelly",
      location: "Brooklyn, NY",
    },
    {
      stars: "★★★★★",
      text: `"Diddy Baby Oil has definitely made things more exciting for us! It feels amazing on the skin, and the scent is just right. It’s been a great way to add a little extra intimacy to our time together."`,
      author: "Sarah Miller",
      location: "Miami, FL",
    },
    {
      stars: "★★★★★",
      text: `"Love Diddy Baby Oil! It’s smooth, sensual, and has the perfect scent. My partner and I use it all the time now—it’s definitely become a must-have for us."`,
      author: "John D.",
      location: "New York, NY",
    },
  ];

  return (
    <section className="testimonial-section">
      <div className="container-xl">
        <div className="testimonial-carousel">
          <Swiper
            modules={[Navigation]}
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            navigation={{
              nextEl: ".testimonial-swiper-button-next",
              prevEl: ".testimonial-swiper-button-prev",
            }}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 3, spaceBetween: 20 },
            }}
            className="testimonial-swiper"
            onSwiper={(swiper) => {
              const updateHeight = () => {
                let maxHeight = 0;
                swiper.slides.forEach((slide) => {
                  maxHeight = Math.max(maxHeight, slide.offsetHeight);
                });
                swiper.el.style.height = `${maxHeight}px`;
              };

              swiper.on("slideChange", updateHeight);
              swiper.on("resize", updateHeight);
              updateHeight();
            }}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <div className="testimonial-card__stars">
                    {testimonial.stars}
                  </div>
                  <div className="testimonial-card__text">
                    {testimonial.text}
                  </div>
                  <div className="testimonial-card__author">
                    {testimonial.author}
                  </div>
                  <div className="testimonial-card__location">
                    {testimonial.location}
                  </div>
                </div>
              </SwiperSlide>
            ))}
            
          </Swiper>
          <div className="testimonial-swiper-button-next swiper-button-next"></div>
            <div className="testimonial-swiper-button-prev swiper-button-prev"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
